import script from "./ContributorOverviewDays.vue?vue&type=script&setup=true&lang=js"
export * from "./ContributorOverviewDays.vue?vue&type=script&setup=true&lang=js"

import "./ContributorOverviewDays.vue?vue&type=style&index=0&id=04aaf9f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04aaf9f3"]])

export default __exports__